import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 3,
  path: '/standardization',
  component: Home,
  redirect: '/standardization/standardization/index',
  name: 'standardization',
  isHead: true,
  meta: {
    title: '标准化建设',
    icon: 'el-icon-s-marketing'
  },
  children: [
    {
      path: 'standardization',
      component: () => import('@/views/selfEvaluation/index'),
      name: 'standardization',
      meta: { title: '标准化建设', close: false },
      children: [{
        path: 'index',
        component: () => import('@/views/standardization/index'),
        name: 'Standardization',
        meta: { title: '企业标准化运行管理', next: '/standardization/standardization/selfStandardization', close: false }
      }, {
        path: 'selfStandardization',
        component: () => import('@/views/selfStandardization/index'),
        name: 'selfStandardization',
        meta: { title: '企业标准化自评管理', next: '/standardization/standardization/selfSetting', close: false }
      }, {
        path: 'selfSetting',
        name: 'selfSetting',
        component: () => import('@/views/selfEvaluation/maintain/index'),
        meta: {title: '评定细则维护', close: false}
      }]
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/standardization.js